import { render, staticRenderFns } from "./WelcomeDia.vue?vue&type=template&id=54c6ff42&scoped=true&"
import script from "./WelcomeDia.vue?vue&type=script&lang=js&"
export * from "./WelcomeDia.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeDia.vue?vue&type=style&index=0&id=54c6ff42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c6ff42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54c6ff42')) {
      api.createRecord('54c6ff42', component.options)
    } else {
      api.reload('54c6ff42', component.options)
    }
    module.hot.accept("./WelcomeDia.vue?vue&type=template&id=54c6ff42&scoped=true&", function () {
      api.rerender('54c6ff42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/code/welcome/WelcomeDia.vue"
export default component.exports